<div
  class="sticky-element"
  [class.fixed]="fixed"
  #element
  [style.top]="
    stickTo === 'top'
      ? atBottom
        ? 'auto'
        : paddingY + (fixed ? offsetTop : 0) + 'px'
      : atTop
        ? paddingY + 'px'
        : 'auto'
  "
  [style.right]="left ? 'auto' : paddingX + 'px'"
  [style.left]="left ? paddingX + 'px' : 'auto'"
  [style.zIndex]="zIndex"
  [style.bottom]="
    stickTo === 'bottom'
      ? atTop
        ? 'auto'
        : paddingY + (fixed ? offsetBottomWithSafeArea() : 0) + 'px'
      : atBottom
        ? (paddingYBottom ?? paddingY) + 'px'
        : 'auto'
  "
  [style.height]="autoFill ? height + 'px' : 'auto'"
  [class.full-width]="fullWidth"
>
  <ng-content></ng-content>
</div>
